module.exports = __webpack_public_path__ + "assets/img/angry_baby.2070876e.jpg";